import { IonButton, IonContent, IonIcon, IonPopover, IonTextarea } from "@ionic/react";
import { addCircleOutline, chatboxEllipsesOutline, pencilOutline } from "ionicons/icons";
import React, { FC, useState } from "react";
import AE2Modal from "../../elements/AE2Modal";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";

interface IProps {className:string | null,
    id:string,
    hasNote:boolean,
    note:string | null,
    handleTargets:()=>{}
};

async function saveNotes(token: string,id:any,data:any) {
  return fetch(`${API_URL}/ae2_energy_targets/edit_note/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(data)
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Error Saving Data")
                // throw error here to use the catch
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Error Saving Data")
      });
}

const EnergyTargetNoteBtn:FC<IProps> = ({className,id,hasNote,note, handleTargets}) => {

     const [targetNote,setTargetNote] = useState<any>(note);
     const [showModal,setShowModal] = useState(false);

     const handleNote = async () => {
        const token = localStorage.getItem('token');
        const res = await saveNotes(`Token ${token!.slice(1,-1)}`, id, {note: targetNote})
            if (res) {                
                setShowModal(false);
                NotificationPopUp("success", "Note Saved Successfully");
                if(!hasNote || targetNote===''){
                    handleTargets()
                }
            }
        }
  
    return <div>
        {
            !hasNote ? <IonIcon className={hasNote ? 'note-icon' : 'no-note-icon'} onClick={()=>setShowModal(true)} title="Add Note" src={addCircleOutline} />  :
            <div>
                <IonIcon id={`note-${id}-trigger`} className="notes-icon-btn" title="Notes" src={chatboxEllipsesOutline} />
                <IonPopover 
                    trigger={`note-${id}-trigger`}
                    side="top" 
                    alignment="center"
                    triggerAction="click"
                    showBackdrop={false}
                    mode='ios'
                    >                
                    <IonContent class="ion-padding">
                        <div style={{
                            position:'relative',                                                        
                        }}                        
                        >
                            <IonIcon 
                                style = {{
                                    position:'absolute',
                                    right:'-10px',
                                    top:'-12px',
                                }}
                                className="notes-icon-btn"
                                title='EditNote' 
                                src={pencilOutline}
                                onClick={()=>setShowModal(true)}/>
                        </div>
                        <div style={{
                            padding:'0px',
                            margin:'0px'
                        }}
                        >
                           {targetNote}
                        </div>
                    </IonContent>
                </IonPopover>
            </div>
        }
        <AE2Modal opened={showModal} setOpened={setShowModal} title="Note"  style={{'--height':'220px'}}>
            <IonTextarea
            className="notes-text"
            label="Add Notes:"
            labelPlacement="floating"
            fill="outline"
            value = {targetNote}
            onIonInput={(e)=>setTargetNote(e.detail.value)}
            style={{color:'white'}}
            counter={true}
            maxlength={300}
            counterFormatter={(inputLength, maxLength) => `${maxLength - inputLength} characters remaining`}
        >   </IonTextarea>
            <div style={{display:'flex', justifyContent:'center'}}>
                <IonButton style={{marginTop:'10px'}} onClick={()=>handleNote()}>Save</IonButton>
            </div>
        </AE2Modal>
    </div>
};

export default EnergyTargetNoteBtn;